module.exports = __webpack_public_path__ + "static/media/logo2.7968db90.png";